import Header from '../components/Header';
import './Home.css';
import Description from '../components/Description';



function Home() {
    return ( 
        <div className = "App" >
            <Header />
            <Description />
        </div >
    );
}

export default Home;